var map = {
	"./commandsIcons/icon-generic-day.svg": "dc5b",
	"./commandsIcons/icon-generic-entrance.svg": "fc11",
	"./commandsIcons/icon-generic-exit.svg": "4420",
	"./commandsIcons/icon-generic-fan.svg": "61a7",
	"./commandsIcons/icon-generic-generic1.svg": "9a19",
	"./commandsIcons/icon-generic-generic2.svg": "a6d9",
	"./commandsIcons/icon-generic-generic3.svg": "d96d",
	"./commandsIcons/icon-generic-generic4.svg": "960b",
	"./commandsIcons/icon-generic-generic5.svg": "a61d",
	"./commandsIcons/icon-generic-generic6.svg": "75b6",
	"./commandsIcons/icon-generic-generic7.svg": "29a6",
	"./commandsIcons/icon-generic-generic8.svg": "8700",
	"./commandsIcons/icon-generic-generic9.svg": "034a",
	"./commandsIcons/icon-generic-key.svg": "2a49",
	"./commandsIcons/icon-generic-night.svg": "b015",
	"./commandsIcons/icon-generic-ring.svg": "5036",
	"./commandsIcons/icon-letter-a.svg": "cd09",
	"./commandsIcons/icon-letter-b.svg": "ac42",
	"./commandsIcons/icon-letter-c.svg": "5ea2",
	"./commandsIcons/icon-letter-d.svg": "5dde",
	"./commandsIcons/icon-letter-e.svg": "e81c",
	"./commandsIcons/icon-letter-f.svg": "2854",
	"./commandsIcons/icon-letter-g.svg": "4034",
	"./commandsIcons/icon-letter-h.svg": "0e17",
	"./commandsIcons/icon-letter-i.svg": "a6f1",
	"./commandsIcons/icon-letter-j.svg": "de97",
	"./commandsIcons/icon-letter-k.svg": "319b",
	"./commandsIcons/icon-letter-l.svg": "77d3",
	"./commandsIcons/icon-letter-m.svg": "4215",
	"./commandsIcons/icon-letter-n.svg": "5174",
	"./commandsIcons/icon-letter-o.svg": "2bce",
	"./commandsIcons/icon-letter-p.svg": "4b22",
	"./commandsIcons/icon-letter-q.svg": "7533",
	"./commandsIcons/icon-letter-r.svg": "29f4",
	"./commandsIcons/icon-letter-s.svg": "3a20",
	"./commandsIcons/icon-letter-t.svg": "bdce",
	"./commandsIcons/icon-letter-u.svg": "a5ca",
	"./commandsIcons/icon-letter-v.svg": "fa4a",
	"./commandsIcons/icon-letter-w.svg": "4305",
	"./commandsIcons/icon-letter-x.svg": "0f7a",
	"./commandsIcons/icon-letter-y.svg": "c252",
	"./commandsIcons/icon-letter-z.svg": "69e8",
	"./commandsIcons/icon-number-eight.svg": "0139",
	"./commandsIcons/icon-number-five.svg": "c9b2",
	"./commandsIcons/icon-number-four.svg": "c49a",
	"./commandsIcons/icon-number-nine.svg": "18c4",
	"./commandsIcons/icon-number-one.svg": "b307",
	"./commandsIcons/icon-number-seven.svg": "3b0e",
	"./commandsIcons/icon-number-six.svg": "35ef",
	"./commandsIcons/icon-number-three.svg": "3e98",
	"./commandsIcons/icon-number-two.svg": "c9ac",
	"./commandsIcons/icon-number-zero.svg": "ec91",
	"./entrancePlants/guest-one-time.svg": "d345",
	"./entrancePlants/guest-periodic.svg": "9ae0",
	"./entrancePlants/icon-apartment.svg": "a690",
	"./entrancePlants/icon-badge.svg": "c8b7",
	"./entrancePlants/icon-building.svg": "8cea",
	"./entrancePlants/icon-gate.svg": "730c",
	"./entrancePlants/icon-guest.svg": "f0a6",
	"./entrancePlants/icon-keypad.svg": "6995",
	"./entrancePlants/icon-locket.svg": "f96a",
	"./entrancePlants/icon-message.svg": "2317",
	"./entrancePlants/icon-new-pe.svg": "6da0",
	"./entrancePlants/icon-parameters.svg": "30ed",
	"./entrancePlants/icon-plant-configured.svg": "5849",
	"./entrancePlants/icon-resident.svg": "a878",
	"./entrancePlants/icon-riser.svg": "2f7f",
	"./entrancePlants/icon-smart-reader.svg": "abf8",
	"./entrancePlants/icon-switchboard.svg": "e18c",
	"./entrancePlants/tab-edited.svg": "9509",
	"./icon-check.svg": "8821",
	"./icons/icon-actuator-2.svg": "46f4",
	"./icons/icon-add-circle-outline.svg": "a2b6",
	"./icons/icon-add-outline.svg": "94b1",
	"./icons/icon-add.svg": "605f",
	"./icons/icon-alert-hight-full.svg": "0450",
	"./icons/icon-alert-hight-outline.svg": "4a7c",
	"./icons/icon-alert-medium-full.svg": "df0f",
	"./icons/icon-alert-medium-outline.svg": "8c5c",
	"./icons/icon-alert-triangle-outline.svg": "9cb1",
	"./icons/icon-all-plants.svg": "15c1",
	"./icons/icon-arrows-back.svg": "6b1a",
	"./icons/icon-arrows-down.svg": "7526",
	"./icons/icon-arrows-next.svg": "8cbd",
	"./icons/icon-arrows-up.svg": "764e",
	"./icons/icon-assistant.svg": "8049",
	"./icons/icon-automation-2.svg": "1f93",
	"./icons/icon-automation.svg": "33d3",
	"./icons/icon-ban-light.svg": "cba1",
	"./icons/icon-bathroom.svg": "3a90",
	"./icons/icon-bedroom.svg": "2dc5",
	"./icons/icon-blind.svg": "3343",
	"./icons/icon-blueprint.svg": "50da",
	"./icons/icon-book.svg": "a24e",
	"./icons/icon-checkbox-disabled.svg": "7a74",
	"./icons/icon-close.svg": "9f16",
	"./icons/icon-colored-light.svg": "89d8",
	"./icons/icon-command.svg": "df05",
	"./icons/icon-confirm-full.svg": "754d",
	"./icons/icon-confirm-outline.svg": "56b2",
	"./icons/icon-connected-server.svg": "a17c",
	"./icons/icon-corridor.svg": "b9ef",
	"./icons/icon-datetime.svg": "1496",
	"./icons/icon-delete.svg": "94ba",
	"./icons/icon-desktop.svg": "983e",
	"./icons/icon-device.svg": "03b8",
	"./icons/icon-dimmer-dmx.svg": "7a49",
	"./icons/icon-diningroom.svg": "501c",
	"./icons/icon-done.svg": "1e96",
	"./icons/icon-duplication-all.svg": "b32a",
	"./icons/icon-duplication.svg": "3a03",
	"./icons/icon-edit-page.svg": "d0d6",
	"./icons/icon-edit.svg": "1eee",
	"./icons/icon-electrical-cabinet.svg": "2aa1",
	"./icons/icon-ellipsis-v.svg": "137d",
	"./icons/icon-email.svg": "f1cb",
	"./icons/icon-energy-dishwasher.svg": "d560",
	"./icons/icon-energy-dryer.svg": "ddc8",
	"./icons/icon-energy-energy.svg": "f6d0",
	"./icons/icon-energy-fridge.svg": "cd9d",
	"./icons/icon-energy-internet-box.svg": "ae3d",
	"./icons/icon-energy-light-socket.svg": "5c93",
	"./icons/icon-energy-multimedia.svg": "84b6",
	"./icons/icon-energy-oven.svg": "ed67",
	"./icons/icon-energy-washing.svg": "dc0d",
	"./icons/icon-energy.svg": "b05d",
	"./icons/icon-entrance.svg": "b000",
	"./icons/icon-expand-menu.svg": "420d",
	"./icons/icon-failed-full.svg": "a6b2",
	"./icons/icon-failed-outline.svg": "78b2",
	"./icons/icon-fancoil.svg": "7b42",
	"./icons/icon-faq.svg": "3437",
	"./icons/icon-favourite-outline.svg": "efba",
	"./icons/icon-favourite.svg": "ef9e",
	"./icons/icon-filter.svg": "0931",
	"./icons/icon-filters.svg": "f5b0",
	"./icons/icon-floor-call.svg": "1eca",
	"./icons/icon-garage.svg": "e25a",
	"./icons/icon-garden.svg": "18bc",
	"./icons/icon-general-light.svg": "8bae",
	"./icons/icon-general-object.svg": "8842",
	"./icons/icon-general-view.svg": "1cb3",
	"./icons/icon-grid.svg": "5084",
	"./icons/icon-group-lights.svg": "c7c0",
	"./icons/icon-import.svg": "467b",
	"./icons/icon-info-circle.svg": "d5db",
	"./icons/icon-kitchen.svg": "f795",
	"./icons/icon-laundry.svg": "26cc",
	"./icons/icon-less.svg": "1fe0",
	"./icons/icon-light.svg": "2967",
	"./icons/icon-list.svg": "9a3b",
	"./icons/icon-livingroom.svg": "2d2a",
	"./icons/icon-load-control.svg": "554a",
	"./icons/icon-loading.svg": "e315",
	"./icons/icon-lock.svg": "a1b1",
	"./icons/icon-mail.svg": "aaa7",
	"./icons/icon-mobile-device.svg": "fcc4",
	"./icons/icon-music-player.svg": "2a2b",
	"./icons/icon-mx-server.svg": "eba1",
	"./icons/icon-network.svg": "e331",
	"./icons/icon-no-view.svg": "c6d8",
	"./icons/icon-notification.svg": "dce2",
	"./icons/icon-office.svg": "790c",
	"./icons/icon-outdoor.svg": "6f2c",
	"./icons/icon-paperclip.svg": "fa60",
	"./icons/icon-plan-duplicate.svg": "fffe",
	"./icons/icon-plants.svg": "f643",
	"./icons/icon-player.svg": "c733",
	"./icons/icon-plus-outline.svg": "1212",
	"./icons/icon-profile.svg": "4fab",
	"./icons/icon-push-notification.svg": "6d4c",
	"./icons/icon-refresh.svg": "1af7",
	"./icons/icon-remove-hand-02.svg": "797b",
	"./icons/icon-remove-outline.svg": "79ab",
	"./icons/icon-reorder-drag-and-drop.svg": "fcb4",
	"./icons/icon-room.svg": "a24d",
	"./icons/icon-round-outline.svg": "5115",
	"./icons/icon-round.svg": "0b54",
	"./icons/icon-scan-qr-code-02.svg": "b205",
	"./icons/icon-scene.svg": "c4c4",
	"./icons/icon-search.svg": "6a1a",
	"./icons/icon-security-2.svg": "2f55",
	"./icons/icon-security.svg": "a13f",
	"./icons/icon-server-f460.svg": "e6de",
	"./icons/icon-server-mhs-1.svg": "63ec",
	"./icons/icon-setting.svg": "e942",
	"./icons/icon-shutter.svg": "1e5c",
	"./icons/icon-socket.svg": "4e1f",
	"./icons/icon-staff.svg": "8dec",
	"./icons/icon-staircase.svg": "a1a2",
	"./icons/icon-star.svg": "0c24",
	"./icons/icon-start-plan.svg": "f9fc",
	"./icons/icon-sync.svg": "4e9a",
	"./icons/icon-thermo.svg": "dc59",
	"./icons/icon-thermostat.svg": "a231",
	"./icons/icon-toilets.svg": "01b6",
	"./icons/icon-towel-rail.svg": "2a06",
	"./icons/icon-user.svg": "a26a",
	"./icons/icon-weather.svg": "e6c0",
	"./icons/icon-wifi-01-1.svg": "c297",
	"./icons/icon-wifi.svg": "f077",
	"./icons/icon-wizard-assegna-attuatore.svg": "6a9d",
	"./icons/icon-xmeter.svg": "0519",
	"./icons/icon_command_day.svg": "78b0",
	"./icons/icon_command_enter.svg": "afda",
	"./icons/icon_command_exit.svg": "c34e",
	"./icons/icon_command_night.svg": "0ec0",
	"./icons/icon_parameters_and_settings_folder_2.svg": "14b1",
	"./logo-text-min.svg": "8baa",
	"./logo.svg": "e347",
	"./plants/server/image_gateway_c300eos.svg": "d896",
	"./plants/server/image_gateway_f460.svg": "c026",
	"./plants/server/image_gateway_mhs1.svg": "a483"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";